import React from 'react';
import EconomicResearchComponent from "./EconomicResearchComponent";

const EconomicResearchContainer: React.FC = () => {

    return (
        <EconomicResearchComponent />
    );
};

export default EconomicResearchContainer;
